import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DistanceFilterContainer = styled.div`
  color: ${({ theme }) => theme.colors.gray300};
  font-size: 12px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 15px 0;
  ul {
    list-style: none;
    display: flex;
    li {
      margin: 0 5px;
      button {
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
        outline: 0;
        border-radius: 15px;
        padding: 3px 10px;
        background-color: transparent;
        color: ${({ theme }) => theme.colors.gray300};
        border: 1px solid ${({ theme }) => theme.colors.gray300};
        &.active {
          color: #fff;
          border-color: #fff;
        }
      }
    }
  }
`;

function DistanceFilter({ value, distances, onSelect }) {
  return (
    <DistanceFilterContainer>
      Filtro por distância:
      <ul>
        {distances.map(distance => (
          <li key={`distance-option-${distance}`}>
            <button
              className={value === distance ? 'active' : ''}
              type="button"
              onClick={() => onSelect(distance)}
            >
              {distance} km
            </button>
          </li>
        ))}
      </ul>
    </DistanceFilterContainer>
  );
}

DistanceFilter.propTypes = {
  distances: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DistanceFilter;
